module.exports = __webpack_public_path__ + "assets/img/Slice 164.73e1b75c.png";